import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import ReactPaginate from "react-paginate";

const Pagination = ({ perPage, setPerPage, onPageChange, total, page }) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4 px-2">
      {/* Total Count */}
      

      {/* Per Page Selector */}
      <div className=" flex  items-center gap-2 rounded-sm shadow-md bg-indigo-600 px-4">
        <p className="  py-1 fonont-bold text-gray-100">
          Total: 
        </p>
        <div className="text-white font-bold text-lg">
        {total}
        </div>
        
        </div>
      
      <div className="  flex items-center gap-2 ">
        <select
          className="w-full border border-gray-300 rounded-md bg-white py-2 px-3 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400"
          value={perPage}
          onChange={(e) => setPerPage(e.target.value)}
        >
          {[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
            (perPage, index) => (
              <option value={perPage} key={index}>
                {perPage} Per Page
              </option>
            )
          )}
        </select>
        
      </div>

      {/* Pagination */}
      <ReactPaginate
        breakLabel={<span className="mx-2 text-gray-500">...</span>}
        nextLabel={
          <button className="flex items-center justify-center w-8 h-8 rounded-md bg-gray-100 duration-500 hover:bg-indigo-500 hover:text-white">
            <IoIosArrowBack className="rotate-180" />
          </button>
        }
        onPageChange={onPageChange}
        forcePage={page}
        pageRangeDisplayed={5}
        pageCount={Math.ceil(total / perPage)}
        previousLabel={
          <button className="flex items-center justify-center w-8 h-8 rounded-md bg-gray-100 duration-500 hover:bg-indigo-500 hover:text-white">
            <IoIosArrowBack />
          </button>
        }
        renderOnZeroPageCount={null}
        containerClassName="flex items-center justify-center gap-2 mt-4"
        pageClassName="w-8 h-8 flex items-center justify-center duration-500 rounded-md bg-gray-100 hover:bg-indigo-500 hover:text-white"
        pageLinkClassName="w-full h-full flex items-center justify-center"
        activeClassName="bg-indigo-500 text-white shadow-md"
        disabledClassName="opacity-50 cursor-not-allowed"
      />
    </div>
  );
};

export default Pagination;
